import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconControlKeyRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconControlKeyRight"><Path d="M11.5 10L14 7.5L16.5 10M3.5 3.5H20.5V20.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconControlKeyRight;
